import {makeAutoObservable} from "mobx";
import {getStore, useStore} from "../index";


/**
 * 홈페이지 플로팅 영역 Store
 */
export class FloatAreaStore {
    /**
     * 현재 활성화된 플로팅 컨텐츠 타입
     */
    isFloatingContent = null;

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    /**
     * 플로팅 영역 활성화 함수
     *
     * @param {*} type 활성화할 플로팅 타입
     */
    setFloatOpen(type){
        this.isFloatingContent = type;
    }

    /**
     * 플로팅 영역 초기화 함수
     */
    setFloatingClear(){
        this.isFloatingContent = null;
    }

}


/**
 * FloatAreaStore Hook
 *
 * @returns {FloatAreaStore}
 */
export const useFloatAreaStore = () => {
    return useStore().floatAreaStore;
}

/**
 * FloatAreaStore 직접 접근 함수
 *
 * @returns {FloatAreaStore}
 */
export const getFloatAreaStore = () => {
    return getStore().floatAreaStore;
}
